import type {TextSlideItemObject} from '@PosterWhiteboard/items/slideshow-item/slide-items/text-slide-item.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useAppSelector} from '@/hooks';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {SlideshowItemObject} from '@PosterWhiteboard/items/slideshow-item/slideshow-item.class';
import type {TextStylesObject} from '@PosterWhiteboard/classes/text-styles.class';

export function useGetKeyFromTextStylesOfSelectedTextSlideItem<T extends keyof TextStylesObject>(key: T): TextStylesObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.SLIDESHOW) {
      const itemCopy = item as SlideshowItemObject;
      const slideItem = itemCopy.slides.slidesHashMap[itemCopy.selectedSlideUID];

      if (slideItem.gitype === ITEM_TYPE.TEXTSLIDE) {
        const textSlideCopy = slideItem as TextSlideItemObject;
        return textSlideCopy.textStyles[key];
      }
    }

    return undefined;
  });
}
